module.exports = __webpack_public_path__ + "img/badge-de.d5934b6a.png";